import DualloOrganizationClient from "@/clients/duallo/DualloOrganizationClient";

class OrganizationService {

    async getSubscriptionsByOrganizationId(organizationId) {
        return await DualloOrganizationClient.getSubscriptionsByOrganizationId(organizationId);
    }

    async getCurrentSubscriptionByOrganizationIdAsync(organizationId) {
        return await DualloOrganizationClient.getCurrentOrganizationSubscription(organizationId);
    }

    async getOrganizationByAuthZeroOrgId(orgId) {
        return await DualloOrganizationClient.getOrganizationByAuthZeroOrgId(orgId);
    }

    async getSubscriptionUsageRecords(organizationId, period = null) {
        return await DualloOrganizationClient.getSubscriptionUsageRecords(organizationId, period);
    }
}

export default new OrganizationService();
